import React, { useEffect, useState } from "react";
import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";

const DoubleBarChart = ({ feeder_data }) => {
  const [data, setData] = useState({
    education_attainment: [
      "Less than high school diploma",
      "High school diploma or equivalent",
      "Some college, no degree",
      "Associate's degree",
      "Bachelor's degree",
      "Master's degree",
      "Doctoral or professional degree",
    ],
    local_percent: [],
    national_percent: [],
  });

  useEffect(() => {
    let localData = {
      education_attainment: data.education_attainment,
      local_percent: [],
      national_percent: [],
    };
    localData.education_attainment.map((item) => {
      if (item in feeder_data) {
        localData.local_percent.push(feeder_data[item].local_percent);
        localData.national_percent.push(feeder_data[item].national_percent);
      } else {
        localData.local_percent.push(0);
        localData.national_percent.push(0);
      }
    });

    setData({
      ...data,
      local_percent: localData.local_percent,
      national_percent: localData.national_percent,
    });
  }, [feeder_data]);

  const options = {
    chart: {
      type: "column",
      backgroundColor: "transparent",
      height: 680,
      events: {
        load: function() {
          this.container.querySelector(".highcharts-button-box").style.display =
            "none";
          this.container.querySelector(
            ".highcharts-button-symbol"
          ).style.display = "none";
        },
      },
    },
    title: {
      text: null,
      style: {
        color: "#FFFFFF",
      },
    },
    xAxis: {
      categories:
        data.education_attainment.length > 0 && data.education_attainment,
      labels: {
        style: {
          color: "#fff",
          fontSize: "15px",
          fontWeight: "300",
        },
      },
    },
    yAxis: {
      min: 0,
      ceiling: 1,
      title: {
        text: ''
      },
      style: {
        color: "#fff",
        fontSize: "16px",
        fontWeight: "300",
        letterSpacing: "0.49px",
      },
      labels: {
        overflow: "justify",
        style: {
          color: "#fff",
          font: "normal normal normal 18px Arial",
        },
        formatter: function() {
          return Math.round(this.value * 100) + "%";
        },
      },
    },
    plotOptions: {
      series: {
        borderWidth: 0,
      },
    },
    legend: {
      verticalAlign: "top",
      itemStyle: {
        color: "#FFFFFF",
        fontSize: "18px",
        fontWeight: 'normal',
      },
      symbolHeight: 15,
      symbolWidth: 15,
      symbolRadius: 0,
      align: "left",
      verticalAlign: "top",
      layout: "horizontal",
      x: 70,
      y: 0,
      itemMarginTop: 5,
      itemMarginBottom: 5,
    },
    tooltip: {
      formatter: function() {
        return (
          "<b>" +
          this.x +
          "</b><br/>" +
          this.series.name +
          ": " +
          (this.y * 100).toFixed(1) +
          "%"
        );
      },
    },
    series: [
      {
        name: "National",
        data: data.national_percent.length > 0 && data.national_percent,
        color: "#6AA4DC",
      },
      {
        name: "Local",
        data: data.local_percent.length > 0 && data.local_percent,
        color: "#FFB607",
      },
    ],
  };
  return (
    <div>
      <HighchartsReact highcharts={Highcharts} options={options} />
    </div>
  );
};

export default DoubleBarChart;
